class CartCheckoutController {
    constructor(trolleyService, fulfilmentService, settings) {
        this.trolleyService = trolleyService;
        this.fulfilmentService = fulfilmentService;
        this.settings = settings;
    }
}

const cartCheckoutComponentDefinition = {
    controller: ['TrolleyService', 'FulfilmentService', 'Settings', CartCheckoutController],
    template: require('./cart-checkout.component.html').trim(),
};

module.exports = {
    CartCheckoutController,
    cartCheckoutComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/cart/cart-checkout.component.js